module.exports = __webpack_public_path__ + "img/C6.545f2178.png";